import { render, staticRenderFns } from "./orderModel.vue?vue&type=template&id=22304390&scoped=true&"
import script from "./orderModel.vue?vue&type=script&lang=js&"
export * from "./orderModel.vue?vue&type=script&lang=js&"
import style0 from "./orderModel.vue?vue&type=style&index=0&id=22304390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22304390",
  null
  
)

export default component.exports